import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataZXXBMISZCH/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataZXXBMISZCH/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataZXXBMISZCH/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataZXXBMISZCH/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataZXXBMISZCH/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataZXXBMISZCH/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataZXXBMISZCH/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataZXXBMISZCH/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataZXXBMISZCH/update/batch',
    method: 'POST',
    data})
}

   